import { render } from "./ext-users.vue?vue&type=template&id=0e80ea94"
import script from "./ext-users.vue?vue&type=script&lang=js"
export * from "./ext-users.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__